// extracted by mini-css-extract-plugin
export default {"WordPress":"WordPress_WordPress__2QbWB"};